import { useCallback, useEffect, useState } from 'react';
// MIGRATION: fully on AWS PostgREST.
import { aws } from '../lib/awsdb';
import { authWrite } from '../lib/authWrite';

export default function Archive({ session, onSignOut }) {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const all = [];
    const [pos, poInv, contacts] = await Promise.all([
      aws.from('purchase_orders').select('id, po_number, supplier_name, archived_at, archived_by').not('archived_at', 'is', null),
      aws.from('po_invoices').select('id, invoice_number, supplier_name, archived_at, archived_by').not('archived_at', 'is', null),
      aws.from('contacts').select('id, company_name, contact_person, archived_at, archived_by').not('archived_at', 'is', null),
    ]);
    (pos.data || []).forEach(r => all.push({ ...r, _type: 'PO', _name: r.po_number || r.supplier_name || '—', _source: 'PO Tracker' }));
    (poInv.data || []).forEach(r => all.push({ ...r, _type: 'Invoice', _name: r.invoice_number || r.supplier_name || '—', _source: 'PO Tracker' }));
    (contacts.data || []).forEach(r => all.push({ ...r, _type: 'Contact', _name: r.contact_person || r.company_name || '—', _source: 'Address Book' }));
    all.sort((a, b) => (b.archived_at || '').localeCompare(a.archived_at || ''));
    setItems(all);
  }, []);

  useEffect(() => { load(); }, [load]);

  function daysRemaining(archivedAt) {
    if (!archivedAt) return 0;
    const d = new Date(archivedAt);
    const now = new Date();
    const days = 30 - Math.floor((now - d) / (1000 * 60 * 60 * 24));
    return Math.max(0, days);
  }

  function tableFor(type) {
    // general_invoices was dropped in migration 27 — Invoice rows live in
    // po_invoices now.
    return type === 'PO' ? 'purchase_orders'
      : type === 'Invoice' ? 'po_invoices'
      : 'contacts';
  }

  async function restore(item) {
    await authWrite(session, tableFor(item._type), 'update', { archived_at: null, archived_by: null }, { column: 'id', value: item.id });
    load();
  }

  async function burn(item) {
    const typed = prompt('Type BURN to permanently destroy this record:');
    if (typed !== 'BURN') return;
    await authWrite(session, tableFor(item._type), 'delete', null, { column: 'id', value: item.id });
    load();
  }

  return (
    <div className="app-screen">
      <div className="main-content">
        {items.length === 0 ? (
          <div className="gi-empty">Archive is empty. Deleted items appear here for 30 days.</div>
        ) : (
          <div className="gi-table">
            <div className="arc-head">
              <div>Type</div><div>Name</div><div>Source</div><div>Deleted By</div>
              <div>Deleted</div><div>Days Left</div><div>Actions</div>
            </div>
            {items.map(item => {
              const days = daysRemaining(item.archived_at);
              const expired = days <= 0;
              return (
                <div key={`${item._type}-${item.id}`} className="arc-row">
                  <div className="gi-cell"><span className="status-pill draft">{item._type}</span></div>
                  <div className="gi-cell gi-inv-num">{item._name}</div>
                  <div className="gi-cell gi-date">{item._source}</div>
                  <div className="gi-cell">{item.archived_by || '—'}</div>
                  <div className="gi-cell gi-date">{item.archived_at ? new Date(item.archived_at).toLocaleDateString('en-AU') : '—'}</div>
                  <div className="gi-cell" style={{ color: expired ? 'var(--text-error)' : days <= 7 ? '#b45309' : 'var(--text-subdued)' }}>
                    {expired ? 'Expired' : `${days}d`}
                  </div>
                  <div className="gi-cell" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    {!expired && <button className="btn btn-secondary btn-sm" onClick={() => restore(item)}>Restore</button>}
                    {session.role === 'admin' && (
                      <button className="btn btn-danger btn-sm" onClick={() => burn(item)} title="Admin only — permanent delete">
                        &#x1F512; Burn
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
